import { ErrorMessage, Field, Formik } from "formik";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { Texterror } from "../../../constants/Texterror";
import { Icon } from "@iconify/react";
import { ChangePasswordSchema } from "../../../constants/Validation";
import { changePassword, getSession } from "../../../redux/actions/authActions";
import { useDispatch } from "react-redux";
import { Header } from "../../Header";
const ChangePassword = () => {
  const { email } = getSession();
  const dispatch = useDispatch();

  return (
    <div className="profile change_p">
      <Header
        pageTitle="Change Password"
        icon={<Icon icon="mdi:password-outline" className="h-4 w-4" />}
      />
      <div className="h-[calc(100vh-80px)] flex items-center justify-center">
        <div className="card_white_box">
          <h5 className="">
            <span>Change Password</span>
          </h5>
          <Formik
            initialValues={{
              user_email: email || "",
              user_password: "",
              user_new_password: "",
            }}
            validationSchema={ChangePasswordSchema}
            onSubmit={(values, { resetForm }) => {
              dispatch(changePassword(values));
              resetForm();
            }}
          >
            {({ touched, errors, values, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col lg={12}>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${
                          touched.user_email && errors.user_email
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_email"
                        type="email"
                        placeholder="Current Email"
                        value={values.user_email}
                      />
                      <ErrorMessage name="user_email" component={Texterror} />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${
                          touched.user_password && errors.user_password
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_password"
                        type="password"
                        placeholder="Current Password"
                        value={values.user_password}
                      />
                      <ErrorMessage
                        name="user_password"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${
                          touched.user_new_password && errors.user_new_password
                            ? "is-invalid"
                            : ""
                        }`}
                        name="user_new_password"
                        type="password"
                        placeholder="New Password"
                        value={values.user_new_password}
                      />
                      <ErrorMessage
                        name="user_new_password"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      type="submit"
                      className="w-full !rounded-md  !text-sm
                      !bg-primary-blue h-[43px] !border-primary-blue"
                      variant="primary"
                    >
                      Change
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default withRouter(ChangePassword);
